export default import.meta.ROLLDOWN_FILE_URL_DUq8YoikZLXEejpNZ1KQvg_6e6c66a6680f8083bdf80967